import React from 'react';
import StaticNavBar from '../../../components/StaticNavBar/StaticNavBar';
import Breadcrumb from '../../../components/shared/apiLifeCycle/Breadcrumb/Breadcrumb';

const PrivacyPolicy = () => (
  <div className="policyPage">
    <StaticNavBar />
    <Breadcrumb
      title="Privacy Policy"
      bredcrumbFlag={true}
      bredcrumbItems={{
        item1: 'Policy',
        item2: 'Privacy Policy',
      }}
    />
    {/* <div className="breadcrumb-section breadcrumb-section-overide">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="page-title">
                <h2>Privacy Policy</h2>
              </div>
            </div>
            <div className="col-md-6">
              <nav aria-label="breadcrumb" className="theme-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">Policy</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Privacy Policy
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div> */}
    {/* SOmething */}

    <section className="tnc-page section-b-space" style={{ padding: 30 }}>
      <div className="container">
        <div className="bg-white" style={{ padding: '30px' }}>
          <h2>INTRODUCTION</h2>
          <div>
            <hr size="0" width="100%" align="center" />
          </div>
          <p>
            Your privacy is important to us, and we take our responsibility of caring for it
            seriously.   We respect your privacy rights and are committed to protecting the personal
            information that is collected about you and/or protect the information that you provide
            to us. This Privacy Policy describes what information we collect and how we use,
            disclose, transfer, and store it. If you do not want us to collect, store, use or share
            your information in the ways described in this Privacy Policy, you may not be able to
            use our services.
            <br />
            We collect, stores, and uses your information as a data controller and/or data processor
            in connection with, and in order to provide services (“Services”) in accordance with
            this privacy policy (“Privacy Policy”).
            <br />
            All of our Services, whether used on mobile devices, PCs or other platforms, are
            governed by this Privacy Policy. By using the Services, you hereby consent to this
            Privacy Policy.
            <br />
            We reserve the right to change this Privacy Policy at any time. In the event that we
            make material changes to this Privacy Policy, they will be re-posted in the "Privacy"
            section of our websites and apps with the date the modifications were made indicated at
            the top of the page. Therefore, please review this Privacy Policy from time to time so
            that you are aware when any changes are made to it. Your continued use of the Services
            after such change(s) constitutes your acceptance of any such change(s), and if you do
            not accept any changes, you may choose not to use the Services or opt out by sending us
            appropriate notice. If you would like further information about any recent changes made,
            please send your request to [*email*] and include “Information about Changes” in the
            subject line.
          </p>
          <h3>Collection of your information</h3>
          <p>
            We collect some information from you when you: (a) use services, (b) make a purchase
            within our Services and (c) contact our customer service and take part in
            technical-support sessions. The information we may collect includes:-
          </p>
          <p className="font-weight-bold mb-2">i – Information you provide us</p>
          <ul>
            <li>
              Contact information (such as your business name, address, phone no., email address,
              etc)
            </li>
            <li>Distribution List</li>
            <li>
              Information that you provide when seeking help from our customer service (such as chat
              logs and customer-support)
            </li>
            <li>Other information you provide us</li>
          </ul>
          <p className="font-weight-bold mb-2">
            ii – Information we collect automatically directly from you when you use our Services{' '}
          </p>
          <ul>
            <li>IP address and device identifiers (such as your device ID, advertising ID)</li>
            <li>
              Information about your device (such as device name and operating system, browser
              information){' '}
            </li>
            <li>Information we collect using cookies</li>
            <li>General geolocation information </li>
          </ul>
          <p className="font-weight-bold mb-2">iii – Information we obtain from our partners</p>
          <ul>
            <li>
              Information that we receive if you decide to connect to a third-party social network
            </li>
            <li>Information from telco operators and/or billing partners</li>
            <li>
              Information for advertising and analytics purposes, so we can provide you with better
              Services
            </li>
          </ul>
          <h2>Use of your information</h2>
          <p>
            Your information will enable us to provide you with access to all parts of the Sites and
            to supply the goods or services you have requested. It will also enable us to bill you
            and to contact you if necessary, concerning the Services and your ongoing account with
            us. We will also use and analyse the information we collect so that we can administer,
            support, improve and develop our business.
            <br />
            We will normally collect personal information from you only:-
            <ul>
              <li>when we have your consent to do so;</li>
              <li>
                when we need the personal information to fulfill a contract with you and provide you
                with the Services;{' '}
              </li>
              <li>
                when the processing is in our legitimate interests (when we serve and measure the
                effectiveness of advertising or marketing campaigns, protect and improve our
                products and services) and not overridden by your rights; or
              </li>
              <li>when we have a legal obligation to collect personal information from you.</li>
            </ul>
          </p>
          <h3>Retention of your information</h3>
          <p>
            We retain, use and store your information as long as you are playing our games or using
            our Services, and also for the period necessary to fulfill all the purposes described in
            this Privacy Policy, in compliance with the applicable laws of Malaysia. We want to
            inform you that a longer retention period could be required to resolve disputes, or
            answer regulatory or police requests. In such cases, the collected information will be
            used and stored until the request is closed.
          </p>
          <h3>Disclosure of your information</h3>
          <p>
            We may share information we have collected about you in certain situations. Your
            information may be disclosed as follows:-
            <ul>
              <li>
                <p className="font-weight-bold mb-1">By Law or to Protect Rights</p>
                <p className="mt-0">
                  If we believe the release of information about you is necessary to respond to
                  legal process, to investigate or remedy potential violations of our policies, or
                  to protect the rights, property, and safety of others, we may share your
                  information as permitted or required by any applicable law, rule, or regulation.
                  This includes exchanging information with other entities for fraud protection and
                  credit risk reduction.
                </p>
              </li>
              <li>
                <p className="font-weight-bold mb-1">Third-Party Service Providers</p>
                <p className="mt-0">
                  We may share your information with third parties that perform services for us or
                  on our behalf, including payment processing, hosting services, customer service,
                  and marketing assistance.
                </p>
              </li>
              <li>
                <p className="font-weight-bold mb-1">Marketing Communications</p>
                <p className="mt-0">
                  With your consent, or with an opportunity for you to withdraw consent, we may
                  share your information with third parties for marketing purposes, as permitted by
                  law.
                </p>
              </li>
              <li>
                <p className="font-weight-bold mb-1">Third-Party Advertisers</p>
                <p className="mt-0">
                  We may use third-party advertising companies to serve ads when you use the
                  Services. These companies may use information about your use on the Services and
                  other websites that are contained in web cookies in order to provide
                  advertisements about goods and services of interest to you.
                </p>
              </li>
              <li>
                <p className="font-weight-bold mb-1">Affiliates</p>
                <p className="mt-0">
                  We may share your information with our affiliates, in which case we will require
                  those affiliates to honor this Privacy Policy. Affiliates include our parent
                  company and any subsidiaries, joint venture partners or other companies that we
                  control or that are under common control with us.
                </p>
              </li>
              <li>
                <p className="font-weight-bold mb-1">Sale or Liquidation</p>
                <p className="mt-0">
                  If we reorganize or sell all or a portion of our assets, undergo a merger, or are
                  acquired by another entity, we may transfer your information to the successor
                  entity. If we go out of business or enter into liquidation, your information would
                  be an asset transferred or acquired by a third party. You acknowledge that such
                  transfers may occur and that the transferee may decline honor commitments we made
                  in this Privacy Policy.
                </p>
              </li>
            </ul>
            We are not responsible for the actions of third parties with whom you share personal or
            sensitive data, and we have no authority to manage or control third-party solicitations.
            If you no longer wish to receive correspondence, emails or other communications from
            third parties, you are responsible for contacting the third party directly.
          </p>
          <h3>International Operations And Transfers Of Your Information</h3>
          <p>
            As part of our international operations, we may transfer personal information to our
            affiliates (which means subsidiaries, parent companies, joint ventures, and other
            corporate entities under common ownership of [**]) from time to time for our legitimate
            business purposes. 
            <br />
            [**] is headquartered in Malaysia, and we have operations, entities and Services
            provided in Indonesia, Thailand, Philippines, United States and throughout the world. We
            have taken measures to ensure that your personal information is treated securely and
            lawfully, and that it receives an adequate level of protection in the jurisdictions in
            which we process it. If you are located in the European Economic Area (“EEA”) or
            Switzerland, we provide adequate protection for the transfer of personal information to
            countries outside of the EEA or Switzerland based on the standard contractual clauses
            authorized by the European Commission or other appropriate safeguards defined in Article
            46, General Data Protection Regulation (GDPR) (EU) 2016/679.
          </p>
          <h3>Tracking Technologies</h3>
          <p>
            We may use cookies and other tracking technologies on the Services to help customize the
            Services and improve your experience. When you use the Services, your personal
            information is not collected through the use of tracking technology. Most browsers are
            set to accept cookies by default. You can remove or reject cookies, but be aware that
            such action could affect the availability and functionality of the Services.
          </p>
          <h3>Proprietary Rights</h3>
          <p>
            All materials contained on the Services including all content, marks, data, works,
            software, graphics, text, layouts, information, music, video, images, scripts, designs,
            button icons, instructions, illustrations, logo, trademarks, look and feel of the Sites
            and all other intellectual property rights related thereto (“Proprietary Materials”) are
            owned or controlled by Elfo or affiliated companies, our third party licensors. Except
            with our consent, you shall not use the Proprietary Materials, in any way whatsoever,
            other than those provided for herein.
          </p>
          <h3>Third-party Websites</h3>
          <p>
            The Services may link to external sites that are beyond our control. This Privacy Policy
            only covers the way we treat personal information and non-personal information we
            collect on the Services. By accessing any external sites, you agree to the privacy
            policies of those sites. Please understand that external sites may have different
            policies with respect to the collection, use and disclosure of your personal
            information. We have no control over, and are not responsible for, the privacy practices
            of such third parties. 
            <br />
            Therefore, you are encouraged to review the privacy policies of all third parties'
            services. Without limiting anything in the following section, we are not liable in any
            way for the actions, inactions or policies of any external services. 
          </p>
          <h3>Legal Disclaimer </h3>
          <p>
            Our Services operate “AS IS”, and we do not represent or warrant that our Services will
            be available at all times, or that your use of the Services will be uninterrupted or
            error-free. We are not responsible for your ability to access the Services or for
            matters beyond our control.
          </p>
          <h3>Options Regarding Your Information </h3>
          <p>
            We ask that you keep the information that you provide to us updated. You can correct any
            information you have provided to us by contacting us. You represent and warrant that all
            information you provide to us is true and correct, and relates to you and not to any
            other person.  You can exercise your rights at any time and ask us for access to, or
            rectification or erasure of, your information.
            <br />
            Please note that other third parties (our data partners) may be controllers of your
            information. You can obtain more details and opt out of the sharing of your personal
            information to third parties for any purpose by contacting us. If you have previously
            consented to any direct marketing communication from us or subscribed to our
            newsletters, you can unsubscribe by clicking on a link available in each communication
            and newsletter we send you. If you want to decline to permit cookies or other tracking
            technologies, please read our Cookies Policy on our websites.
            <br />
            Please note that other third parties (our data partners) may be controllers of your
            information. You can obtain more details and opt out of the sharing of your personal
            information to third parties for any purpose by contacting us. If you have previously
            consented to any direct marketing communication from us or subscribed to our
            newsletters, you can unsubscribe by clicking on a link available in each communication
            and newsletter we send you. If you want to decline to permit cookies or other tracking
            technologies, please read our Cookies Policy on our websites.
            <br />
            Please note that the Services and features can be affected by your actions. Some of your
            information and its processing is mandatory for us to provide the Services. Your actions
            can oblige us to stop providing the Services: -
          </p>
          <ul>
            <li>
              If you ask for the modification of this mandatory information, we may not be able to
              continue to link the Services to you.
            </li>
            <li>
              If you request limitations to processing that are mandatory for us, or you object to
              such processing (in which case, we may not be able to provide you with the Services).
            </li>
            <li>
              If you withdraw your consent or ask for the deletion of your information, we will not
              use or process your information anymore but we will store it to answer regulatory or
              police requests. We also reserve the right to retain an archive of such information
              for a commercially reasonable time to ensure that its deletion does not affect the
              integrity of our data; and we further reserve the right to retain an anonymous version
              of such information.
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
);

export default PrivacyPolicy;
